/** @format */

import {
  Button,
  Tooltip,
  Stack,
} from "@mui/material";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currentBoxSize,
  handleCopyBoxButton,
  handleEraseToggleButton,
  handleImageToggleButton,
  handleTextToggleButton,
  handleToggleButton,
} from "../../../../../store/reducers/pdfeditor/toolsModificationSlice";
import {
  deleteCoordinate,
  pdfCoordinates,
} from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import {
  modifiedCoordinateRedoFunc,
  modifiedCoordinateUndoFunc,
} from "../../../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";

const ToggleButton = ({ activeTool, setActiveTool }) => {
  const [isActive, setIsActive] = useState({
    addText: false,
    eraseToggle: false,
    imageToggle: false,
    copyBoxSize: false,
  });

  const dispatch = useDispatch();
  const { modifiedCoordinates, modifiedCoordinatesRedo } = useSelector(
    (state) => state.pdfAddremoved || []
  );
  const { coordinates } = useSelector((state) => state.pdfCoordinates || []);

  const handleSwitchToggle = () => {
    setActiveTool({ toggleButton: true });
    setIsActive({ copyBoxSize: true });
  };

  const handleBoxesToggle = (toggleText) => {
    if (toggleText === "addText") {
      setIsActive({ addText: true });
      setActiveTool({ toggleButton: true });
      dispatch(handleTextToggleButton(isActive.addText));
      dispatch(currentBoxSize({ height: 40, width: 100 }));
    } else if (toggleText === "addImage") {
      setIsActive({ imageToggle: true });
      setActiveTool({ toggleButton: true });
      dispatch(handleImageToggleButton(isActive.imageToggle));
      dispatch(currentBoxSize({ height: 150, width: 150 }));
    }
  };

  const handleUndo = () => {
    if (modifiedCoordinates?.length > 0) {
      let poppedItem = [...modifiedCoordinates].pop();
      if (poppedItem) {
        setActiveTool({ toggleButton: true });
        if (poppedItem?.action === "removed") {
          dispatch(modifiedCoordinateUndoFunc(poppedItem));
          dispatch(pdfCoordinates(poppedItem));
        } else if (poppedItem?.action === "added") {
          let actualItem = coordinates?.filter(
            (item) => item.id === poppedItem?.id
          );
          if (actualItem?.length > 0) {
            dispatch(
              modifiedCoordinateUndoFunc({ action: "added", ...actualItem[0] })
            );
            dispatch(deleteCoordinate(poppedItem.id));
          }
        }
      }
    }
  };

  const handleRedo = () => {
    if (modifiedCoordinatesRedo?.length > 0) {
      setActiveTool({ toggleButton: true });
      let poppedItem = [...modifiedCoordinatesRedo].pop();
      if (poppedItem) {
        if (poppedItem?.action === "removed") {
          dispatch(deleteCoordinate(poppedItem?.id));
          dispatch(modifiedCoordinateRedoFunc(poppedItem));
        } else if (poppedItem?.action === "added") {
          dispatch(pdfCoordinates({ action: "added", ...poppedItem }));
          dispatch(modifiedCoordinateRedoFunc(poppedItem));
        }
      }
    }
  };

  useEffect(() => {
    dispatch(handleToggleButton(isActive.copyBoxSize));
  }, [isActive.copyBoxSize, dispatch]);

  useEffect(() => {
    dispatch(handleTextToggleButton(isActive.addText));
  }, [isActive.addText, dispatch]);

  useEffect(() => {
    dispatch(handleImageToggleButton(isActive.imageToggle));
  }, [isActive.imageToggle, dispatch]);

  return (
    <Stack direction={"row"} alignItems={"center"} spacing={2}>
      <Tooltip placement='bottom' title='Copy Box Size'>
        <Button
          onClick={handleSwitchToggle}
          height={"20px"}
          sx={{ textTransform: "capitalize", fontSize: "11px" }}
          variant={
            activeTool.toggleButton && isActive.copyBoxSize
              ? "contained"
              : "outlined"
          }
        >
          <ContentCopyIcon />
        </Button>
      </Tooltip>
      {/* <Tooltip placement='bottom' title='Text Box'>
        <Button
          onClick={() => handleBoxesToggle("addText")}
          height={"20px"}
          sx={{ textTransform: "capitalize", fontSize: "11px" }}
          variant={
            activeTool.toggleButton && isActive.addText
              ? "contained"
              : "outlined"
          }
        >
          <TextFieldsIcon />
        </Button>
      </Tooltip> */}
      {/* <Tooltip placement='bottom' title='Add Image'>
        <Button
          onClick={() => handleBoxesToggle("addImage")}
          height={"20px"}
          sx={{ textTransform: "capitalize", fontSize: "11px" }}
          variant={
            activeTool.toggleButton && isActive.imageToggle
              ? "contained"
              : "outlined"
          }
        >
          <AddPhotoAlternateIcon />
        </Button>
      </Tooltip> */}
      <Tooltip placement='bottom' title='Undo'>
        <Button onClick={handleUndo} height={"20px"} variant={"outlined"} disabled={modifiedCoordinates?.length <= 0}>
          <UndoIcon />
        </Button>
      </Tooltip>
      <Tooltip placement='bottom' title='Redo'>
        <Button onClick={handleRedo} height={"20px"} variant={"outlined"} disabled={modifiedCoordinatesRedo?.length <= 0}>
          <RedoIcon />
        </Button>
      </Tooltip>
    </Stack>
  );
};

export default ToggleButton;
